import { useCompanies } from "../lib/api";
import { monogram } from "../lib/company";

/**
 * Logo of a company: the file attached to the ERPNext Company record when the caller can read it, else a text
 * monogram of its abbreviation. Sized by height so mixed logo shapes line up.
 */
export function CompanyLogo({ company, size = 24, showName = false, className = "" }: {
  company: string | null | undefined;
  size?: number;
  showName?: boolean;
  className?: string;
}) {
  const companies = useCompanies();
  if (!company) return null;
  const record = companies.data?.find((c) => c.name === company);
  const src = record?.company_logo;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} title={company}>
      {src ? (
        <img src={src} alt={company} style={{ height: size, maxWidth: size * 5 }} className="object-contain" loading="lazy" />
      ) : (
        <span className="inline-flex items-center justify-center rounded bg-brand-grey-light px-1 font-heading text-[10px] font-semibold text-brand-charcoal"
          style={{ height: size, minWidth: size }}>
          {monogram({ name: company, abbr: record?.abbr })}
        </span>
      )}
      {showName && <span className="truncate">{company}</span>}
    </span>
  );
}
